import { Grid, CardContent } from "@mui/material";
import { IFlightPairingDetails, IFullFlight } from "@vmosolutions/oc-interfaces";
import { FormHeader } from "../helpers";
import { FlightLog } from "src/pages/FlightEditor/FlightLog";
import { IFormHandle } from "../helpers";

interface ILogTabProps {
  fullFlight: IFullFlight; // Id of the flight to retrieve and edit if provided.
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus: (statusMessage: string) => void;
  crewOnFlight: Record<string, IFlightPairingDetails[]>;
  setLoadedFlight: (flightValues: IFullFlight) => void;
  registerFormHandle?: (tabId: string, handle: IFormHandle | null) => void;
  saveAllDirtyTabs?: (excludeTabId?: string) => Promise<void>;
}

/**
 * Flight Log Tab
 * @param props -
 */
export const LogTab = (props: ILogTabProps): JSX.Element => {
  const { fullFlight, updateTabState, mosaicId, crewOnFlight, setLoadedFlight, registerFormHandle, saveAllDirtyTabs } = props;

  return (
    <CardContent id={`${mosaicId}-log-editor`} className="form_card log">
      <Grid container direction="column">
        <FormHeader title="Log" subtitle="" />
        {fullFlight ? (
          <FlightLog
            windowId={mosaicId}
            flight={fullFlight}
            updateTabState={updateTabState}
            crewOnFlight={crewOnFlight}
            setLoadedFlight={setLoadedFlight}
            registerFormHandle={registerFormHandle}
            saveAllDirtyTabs={saveAllDirtyTabs}
          />
        ) : null}
      </Grid>
    </CardContent>
  );
};
